import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, FontWeight, Media } from '../../theme';
import { hexToRgba, styleWhenTrue } from '../../utils';

import { CookiePopupContainerData } from './cookiePopup.types';

export const Container = styled.div<CookiePopupContainerData>`
  max-height: 0;
  transition: max-height 0.5s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 260px;
  box-shadow: 0 0 6px 0 ${hexToRgba(Color.black, 0.1)}, 0 0 10px 0 ${hexToRgba(Color.black, 0.02)};
  background-color: ${Color.white};
  color: ${Color.darkGrey};
  margin-top: 5px;
  ${styleWhenTrue(prop('isVisible'), css`
    max-height: 250px;
  `)}
`;

export const ContentSection = styled.div`
  padding: 19px;
  border-bottom: 1px solid ${Color.mediumLightGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  letter-spacing: 0;
  line-height: 20px;
  flex-direction: column;
`;

export const OKSection = styled.div`
  padding: 12px 0;
  text-align: center;
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  letter-spacing: 0.92px;
  line-height: 15px;
  cursor: pointer;
`;

export const InfoElement = styled.div``;

export const LinkElement = styled.div`
  margin: 3px 10px 0;
  a {
    text-decoration: none;
    color: ${Color.darkSilver};
    font-weight: ${FontWeight.Light};
  }
`;

export const LinkSection = styled.div`
  display: flex;
  align-items: center;
`;

export const Dot = styled.div`
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${Color.darkSilver};
`;
